












import { Component, Prop, Vue } from "vue-property-decorator";
import { ContentBoxModel } from "@/contentful/models";

@Component
export default class BoxWithImage extends Vue {
  @Prop() private item!: ContentBoxModel;

  get target(): string {
    if (this.item.fields.file) {
      return "_blank";
    }
    return "";
  }

  get hasImage(): boolean {
    return !!this.item.fields.topImage;
  }

  get hasFile(): boolean {
    return !!this.item.fields.file;
  }

  get url(): string {
    if (this.item.fields.url) {
      return this.item.fields.url;
    } else if (this.item.fields.file) {
      return this.item.fields.file.fields.file.url;
    }
    return "";
  }

  get backgroundImage(): string {
    return `background-image: url(${this.item.fields.topImage.fields.file.url}?fit=fill&w=370&h=250)`;
  }
}
